<template>
  <div class="b-fff h100p ">
    <a-tabs size="small" v-model:activeKey="state.activeKey">
      <a-tab-pane :key="1" tab="分配权限" force-render>
        <User></User>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="角色管理" force-render>
        <Role></Role>
      </a-tab-pane>
      <a-tab-pane :key="3" tab="模块管理" force-render>
        <Module></Module>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script setup>
import { provide, reactive, toRefs } from 'vue'
import Role from './components/role.vue'
import Module from './components/module.vue'
import User from './components/user.vue'
import useAPI from 'UseApi'
const APIS = useAPI(null, [4410, 4403, 4396])
const state = reactive({
  activeKey: 1,
  APIS
})
provide('APIS', APIS)
</script>
